import { useCallback, useEffect } from 'react';
import { useNextMicro, useSingleton, useUpdate } from '@bydesign-ui/hooks';
import { SchedulePanel } from '../../../models/schedule';
import { useSchedule } from './useSchedule';
export function useSchedulePanel() {
  var schedule = useSchedule();
  var panel = useSingleton(function () {
    return new SchedulePanel(schedule);
  });
  var update = useNextMicro(useUpdate());
  useEffect(function () {
    schedule.addListener('repaint-panel', update);
    return function () {
      schedule.removeListener('repaint-panel', update);
    };
  }, []);
  var handleSetValue = useCallback(function (val) {
    schedule.setValue(val);
  }, []);
  var handleClearAll = useCallback(function () {
    schedule.clearValue();
  }, []);
  return {
    datasource: schedule.getDatasource(),
    divider: schedule.getDivider(),
    scheduleList: panel.getScheduleList(),
    displayInfo: schedule.getDisplayInfo(),
    onClearAll: handleClearAll,
    onSetValue: handleSetValue
  };
}